import axios from '../api/index'
export const getConvenios = async () =>{
    return await axios.request('get',`/convenios`)
        .then(res => Promise.resolve(res.data))
}